import Vue from 'vue';
import { formatDate } from '../formatDate';

Vue.filter('date', formatDate)